import React from 'react';
import {
  Box,
  // Container,
  // Typography,
  Grid,
  Card,
  CardContent,
  styled,
  Button
} from '@mui/material';
import {
  // Computer,
  // Speed,
  // People,
  // Security,
  // Support,
  KeyboardArrowDown
} from '@mui/icons-material';
import {CustomLabelSmallBold, CustomLabelSmallRegular,CustomLabelMediumBold, CustomLabelRegularLargeMedium } from '../../common/CustomLabel';

import UIUXIcon from '../../../assets/services/UI_UX Design.png';
import FrontendIcon from '../../../assets/services/Frontend Development.png';
import BackendIcon from '../../../assets/services/Backend Development.png';
import FullStackIcon from '../../../assets/services/Full-Stack Development.png';
import MobileIcon from '../../../assets/services/Mobile Development.png';
import WebAppIcon from '../../../assets/services/Web App Development.png';
import QAIcon from '../../../assets/services/Quality Assurance (QA).png';
import DevOpsIcon from '../../../assets/services/DevOps & Cloud Services.png';
import BrandIcon from '../../../assets/services/Brandkit Design.webp';
import CustomIcon from '../../../assets/services/Custom Software Development.webp';
import AI_ML from '../../../assets/services/AI & ML.webp';
import { Link as RouterLink } from 'react-router-dom';

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  // height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 10,
  boxShadow: 1,
  gap: 2,
  border: "1px solid #E0E0E0",
  transition: 'transform 0.3s ease',
  '&:hover .card-title': {
    color: '#5E17EB !important'
  },
  '&:hover .card-desc': {
    color: 'black !important'
  },
  '&:hover': {
    transform: 'translateY(-5px)'
  }
}));

// const IconWrapper = styled(Box)(({ theme }) => ({
//   marginBottom: theme.spacing(2),  
//   '& .MuiSvgIcon-root': {
//     fontSize: '2.5rem',
//     color: theme.palette.primary.main,
//   },
// }));

const ExpandableContent = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  transition: 'max-height 0.3s ease-in-out',
  maxHeight: 0,
  '&.expanded': {
    maxHeight: '500px', // Adjust this value based on your maximum content height
  }
}));


const ServicesAreasExpertise = () => {
  const [expandedCards, setExpandedCards] = React.useState({});

  const services = [
    {
      icon: <img src={BrandIcon} alt="UI/UX Design" style={{ width: '100px', height: '100px' }} />,
      title: "Brand Kit Design",
      description: "We don’t just design; we create experiences that leave a lasting impression. Our Brand Kit service includes custom logo design, color schemes, typography, and design elements that create a cohesive identity for your digital product.",
      details: [
        <><b>Color Schemes & Typography </b>– A thoughtfully chosen color palette and fonts that reflect your brand’s identity and keep your visuals consistent.</>,
        <><b>Design Elements & Icons </b>– Unique icons, buttons, and other design assets that bring your brand to life and create a smooth user experience.</>,
        <><b>Comprehensive Brand Guidelines </b>– A clear, easy-to-follow guide to ensure your brand looks polished and consistent everywhere it appears.</>,        
      ],
      link: "/brand-kit-detail"
    },
    {
      icon: <img src={UIUXIcon} alt="UI/UX Design" style={{ width: '100px', height: '100px' }} />,
      title: "UI/UX Design",
      description: "We create designs that are easy to use and keep users engaged. Our UX design services help turn visitors into long-term users. The UI/UX design process focuses on understanding your audience, optimizing user journeys, and ensuring accessibility across all devices.",
      details: [
        <><b>User Research & Wireframing</b>– We analyze user behavior and create structured wireframes to ensure intuitive navigation.</>,
        <><b>Custom UI Design</b> – Unique, brand-aligned visuals with a focus on aesthetics and usability.</>,
        <><b>Responsive & Adaptive Design</b> – Seamless experiences across desktops, tablets, and mobile devices.</>,
        <><b>Interactive Prototypes</b> – Test designs before development to refine user experience.</>,
        <><b>Usability Testing</b> – Identify and fix friction points to enhance user retention.</>,
      ],
      link: "/ui-ux-design"
    },
    {
      icon: <img src={FrontendIcon} alt="Frontend Development" style={{ width: '100px', height: '100px' }} />,
      title: "Frontend Development",
      description: "Our developers turn creative designs into fast, interactive websites and mobile apps that users love. We focus on clean code and smooth performance to ensure reliability and efficiency.",
      details: [
        <><b>Component Design</b> – We build reusable UI components that match your design system, keeping the interface consistent and easy to maintain.</>,
        <><b>Responsive Implementation</b> – Our layouts adjust smoothly to different screen sizes, ensuring your website works well on desktops, tablets, and phones.</>,
        <><b>Cross-Browser Testing</b> – We test across major browsers like Chrome, Safari, and Firefox to make sure everything looks and functions correctly.</>,
        <><b>Performance Optimization</b> – We improve load times, animations, and accessibility to create a fast and user-friendly experience.</>,
      ],
      link: "/frontend-dev-detail"
    },
    {
      icon: <img src={BackendIcon} alt="Backend Development" style={{ width: '100px', height: '100px' }} />,
      title: "Backend Development",
      description: "We build strong, secure backends that power smooth, reliable digital experiences. Our solutions handle data efficiently while ensuring scalability and protection.",
      details:[
        <><b>API Architecture</b> – We design RESTful and GraphQL APIs that efficiently handle data and meet frontend needs.</>,
        <><b>Database Schema Setup</b> – We structure scalable SQL and NoSQL databases with security measures to protect data.</>,
        <><b>Server Logic Development</b> – We build the core backend logic, including authentication, data processing, and business rules.</>,
        <><b>Integration & Security</b> – We connect third-party services and enforce encryption, firewalls, and other security protocols.</>,
      ],
      link: "/backend-dev-detail"
    },
    {
      icon: <img src={FullStackIcon} alt="Full-Stack Development" style={{ width: '100px', height: '100px' }} />,
      title: "Full-Stack Development",
      description: "From backend to frontend, our full-stack developers handle it all for smooth and efficient project delivery. We ensure smooth integration and optimal performance at every stage.",
      details:[
        <><b>End-to-End Planning</b> – We align frontend and backend requirements to ensure smooth communication and functionality.</>,
        <><b>Stack Selection</b> – We choose the right frameworks and tools, like React and Node.js, to match project needs.</>,
        <><b>Parallel Development</b> – We build frontend and backend modules at the same time to speed up delivery.</>,
        <><b>Unified Testing</b> – We test integrations, data flow, and user interactions to ensure everything works together flawlessly.</>,
      ],
      link: "/full-stack-detail"
    },
    {
      icon: <img src={MobileIcon} alt="Mobile Development" style={{ width: '100px', height: '100px' }} />,
      title: "Mobile App Development",
      description: "Being the Top IT Consulting Firms in USA, We create mobile apps that are fast, intuitive, and designed to boost user engagement.",
      details:[
        <><b>Platform Analysis</b> – We determine whether native (iOS/Android) or cross-platform (Flutter/React Native) development best suits your needs.</>,
        <><b>Feature Implementation</b> – We integrate essential features like GPS, camera access, and push notifications for a fully functional app.</>,
        <><b>Device Testing</b> – We test on real devices and multiple OS versions to ensure stability and performance.</>,
        <><b>Store Deployment</b> – We optimize your app for App Store and Play Store guidelines, handling submission and approval.</>,
      ],
      link: "/mobile-app-development"
    },
    {
      icon: <img src={WebAppIcon} alt="Web App Development" style={{ width: '100px', height: '100px' }} />,
      title: "Web App Development",
      description: "Our team builds Web Apps that work like Native Apps - fast, reliable, and easy to access from anywhere.",
      details:[
        <><b>Progressive Web Apps (PWAs)</b> – We create web apps that load quickly, work offline, and deliver an app-like experience on any device.</>,
        <><b>Optimized Performance</b> – We ensure fast load times, smooth interactions, and efficient resource usage for a better user experience.</>,
        <><b>Secure & Scalable Architecture</b> – We build web apps with strong security measures and scalable infrastructure to handle growth.</>,
        <><b>Cross-Browser Compatibility</b> – We test and optimize for all major browsers to ensure consistent functionality everywhere.</>,
      ],
      link: "/web-app-development"
    },
    {
      icon: <img src={QAIcon} alt="Quality Assurance (QA)" style={{ width: '100px', height: '100px' }} />,
      title: "Quality Assurance (QA)",
      description: "We test every feature to make sure your product runs smoothly and flawlessly before launch. Our rigorous checks help prevent issues and ensure a great user experience.",
      details:[
        <><b>Test Strategy</b> – We define test cases, select the right tools, and set up automation frameworks for thorough testing.</>,
        <><b>Automated Testing</b> – We script regression, load, and security tests to catch issues early and improve reliability.</>,
        <><b>Bug Tracking</b> – We log, prioritize, and resolve issues efficiently using tools like Jira for a smooth development process.</>,
        <><b>Regression Testing</b> – We revalidate fixes to ensure updates don’t introduce new issues or affect existing functionality.</>,
      ],
      link: "/quality-assurance-detail"
    },
    {
      icon: <img src={DevOpsIcon} alt="DevOps & Cloud Services" style={{ width: '100px', height: '100px' }} />,
      title: "DevOps & Cloud",
      description: "We improve your infrastructure for better performance, security, and easy scaling. Our optimizations reduce downtime and keep your system running efficiently.",
      details:[
        <><b>Infrastructure Setup</b> – We design cloud architectures using AWS, Azure, and Infrastructure as Code (Terraform) for stability and scalability.</>,
        <><b>CI/CD Pipeline</b> – We automate build, test, and deployment workflows to speed up releases and maintain code quality.</>,
        <><b>Monitoring & Logging</b> – We integrate tools like Prometheus and CloudWatch to track performance, detect issues, and enhance reliability.</>,
        <><b>Scalability Management</b> – We optimize auto-scaling, load balancing, and resource allocation to ensure efficiency and cost-effectiveness.</>,
      ],
      link: "/devops-cloud"
    },
    {
      icon: <img src={AI_ML} alt="Artificial Intelligence & Machine Learning" style={{ width: '100px', height: '100px' }} />,
      title: "Artificial Intelligence & Machine Learning",
      description: "We provide the latest AI and machine learning solutions to get smarter decisions and optimize processes. Our AI/ML services help you use data to unlock new opportunities and improve performance.",
      details:[
        <><b>Custom AI Solutions</b> – Customized AI models that meet your specific business needs and objectives.</>,
        <><b>Data Analytics & Insights </b> –Advanced analytics to uncover actionable insights and predict future trends.</>,
        <><b>Predictive Modeling </b> – Use machine learning algorithms to forecast outcomes and optimize strategies.</>,
        <><b>Automation & Optimization</b> – Implement AI-driven automation to enhance efficiency and reduce manual tasks.</>,
        <><b>Natural Language Processing (NLP)</b> –  Enhance communication with intelligent systems capable of understanding and generating human language.</>,
        <><b>AI Integration </b> –  Smooth integration of AI and machine learning technologies into your existing systems for enhanced capabilities.</>,
      ],
      link: "/ai-mechine-learning"
    },
    {
      icon: <img src={CustomIcon} alt="Custom Software Development" style={{ width: '100px', height: '100px' }} />,
      title: "Custom Software Development",
      description: "We build software solutions customized to your business needs. Our custom software development services help you automate processes, improve efficiency, and scale operations. The development process is focused on understanding your goals, choosing the right technology stack, and delivering scalable, secure, and maintainable solutions.",
      details:[
        <><b>Business Analysis & Requirement Gathering</b> – We align technical strategy with your business objectives to define clear software requirements.</>,
        <><b>Customized Software Architecture</b> – Scalable and flexible software architecture built to support current and future growth.</>,
        <><b>Custom Backend & API Development</b> – Powerful backend solutions and smooth API integrations to connect systems and streamline workflows.</>,
        <><b>Cross-Platform Development</b> – Code once, run everywhere - custom apps for web, mobile, or desktop.</>,
        <><b>Quality Assurance & Maintenance</b> – Rigorous testing and ongoing support to ensure stability, security, and performance.</>,
      ],
      link: "/custom-software-development"
    }
  ];

  const handleToggle = (index) => {
    setExpandedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <Grid container sx={{px :{ xs: 1, md: 5}}}>
        <Grid item xs={12} md={12} sx={{margin: {xs: "20px", md: "40px 40px", lg: "40px 40px"}}}>
        <Grid item xs={12} display={"flex"} justifyContent={"center"}>
          <CustomLabelMediumBold textAlign={"center"} text="Custom Software Development Services by Top IT Consulting Firms in the USA" color="#5E17EB" />
        </Grid>      
        <Grid item xs={12} sx={{marginTop : "10px"}}>
          <CustomLabelRegularLargeMedium textAlign ={{xs : "left" , md : "center"}}  lineHeight={"1.5"} text="At OSTRYX, we provide comprehensive Custom Software Development Services, covering everything from brand identity and UI/UX design to full-scale project development and deployment. Whether you need a single expert or a full team, we provide the right talent to get the job done. Here’s what we specialize in:" color="#1A1A1A" />
        </Grid>

        <Grid container spacing={2} sx={{ marginTop: "40px" }}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} key={index}>
              
              <StyledCard sx={{ p: 3 , borderRadius : 10}}>
                <CardContent sx={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  height: '100%',
                  '& > .plain-link': {
                    flex: '1 0 auto'
                  }
                }}>
                <RouterLink to={service.link} className="plain-link">
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                      <CustomLabelSmallBold 
                        color={'#333333'} 
                        text={service.title} 
                        className="card-title"
                      />
                      <CustomLabelSmallRegular className="card-desc" color={'#A3A3A3'} textAlign={"left"} lineHeight={"1.5"} text={service.description}
                      />
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      {service.icon}
                    </Box>
                  </Box>
                  </RouterLink>

                  <Button 
                    onClick={() => handleToggle(index)}
                    sx={{ 
                      alignSelf: 'flex-start',
                      mb: 2,
                      borderRadius: 10,
                      backgroundColor: 'transparent',
                      color: '#333333',
                      border: '1px solid rgb(0, 0, 0)',
                      '&:hover': {
                        backgroundColor: '#5E17EB',
                        color: 'white',
                        border: '1px solid #5E17EB',
                      },
                      textTransform: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    Learn More
                    <KeyboardArrowDown 
                      sx={{ 
                        transition: 'transform 0.3s ease',
                        transform: expandedCards[index] ? 'rotate(-180deg)' : 'rotate(0)',
                      }} 
                    />
                  </Button>

                  <ExpandableContent className={expandedCards[index] ? 'expanded' : ''}>
                    <Box sx={{ opacity: expandedCards[index] ? 1 : 0, transition: 'opacity 0.3s ease-in-out' }}>
                      <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        {service.details?.map((detail, idx) => (
                          <li key={idx}>
                            <CustomLabelSmallRegular textAlign={"left"} lineHeight={"1.5"} text={detail}/>
                          </li>
                        ))}
                      </ul>
                    </Box>
                  </ExpandableContent>
                </CardContent>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
    </Grid>
    </Grid>
  );
};

export default ServicesAreasExpertise;
